import { combineReducers } from "redux";
import createReducer from "utils/createReducer";

import * as list from "./list";
import * as create from "./create";
import * as details from "./details";

export default combineReducers({
  list: createReducer(list),
  create: createReducer(create),
  details: createReducer(details),
});
